export function areMapElementsUnsaved(mapElements) {
  var notAllSaved = false;
  mapElements.forEach((element) => {
    if (notAllSaved) return;
    if (!element.isSaved) notAllSaved = true;
  });

  return notAllSaved;
}
